module.exports = __webpack_public_path__ + "static/media/JEWEL.b1ae5cf0.png";